
import { PropertyHighlight } from '@/types/property';

interface PropertyHighlightsProps {
  highlights: PropertyHighlight[];
}

const PropertyHighlights = ({ highlights }: PropertyHighlightsProps) => {
  return (
    <div className="space-y-6">
      {highlights.map((highlight, index) => (
        <div key={index} className="flex items-start space-x-4">
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">{highlight.title}</h3>
            <p className="text-gray-600">{highlight.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PropertyHighlights;
